// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Redirect } from 'expo-router';

export default function LoginRoute() {
  return <Redirect href="/" />;
}
